import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { ConditionalLink } from '@plone/volto/components';
import { Grid, Embed, Image } from 'semantic-ui-react';
import { getLastVideo } from '../../../actions/videoListing/get_videoListing_lastVideo';
import { useDispatch, useSelector } from 'react-redux';

const VideoListing = (props) => {
  const { items, isEditMode } = props;
  let firstPage = true;
  let lastVideoId;

  const lastVideoIdUrl = useSelector(
    (state) => state.lastVideo.lastVideo?.items?.[0]['@id'],
  );
  let dispatch = useDispatch();
  let lang = useSelector((state) => state.intl.locale);
  useEffect(() => {
    dispatch(getLastVideo(lang));
  }, [dispatch, lang]);

  const firstNavigationVideo = items[0]['@id'].split('/');
  const firstNavigationVideoId =
    firstNavigationVideo[firstNavigationVideo.length - 1];

  const lastVideoIdArray = lastVideoIdUrl?.split('/');

  lastVideoIdArray
    ? (lastVideoId = lastVideoIdArray[lastVideoIdArray.length - 1])
    : (lastVideoId = '');

  lastVideoId === firstNavigationVideoId
    ? (firstPage = true)
    : (firstPage = false);

  return (
    <>
      {firstPage ? ( //With video player
        <div class="container">
          <Grid columns={1}>
            {
              <Grid.Column key={items[0]['@id']} width={12}>
                <Embed
                  id={items[0].video_doc_id}
                  source="youtube"
                  autoplay={false}
                  active={true}
                ></Embed>
              </Grid.Column>
            }
          </Grid>
          <Grid columns={2} stackable doubling>
            {items.slice(1, 3).map((item) => (
              //Image listing
              <Grid.Column key={item['@id']}>
                <ConditionalLink item={item} condition={!isEditMode}>
                  <Image
                    src={`https://i.ytimg.com/vi_webp/${item.video_doc_id}/maxresdefault.webp`}
                  />
                </ConditionalLink>
                <h3>
                  <ConditionalLink item={item} condition={!isEditMode}>
                    {item.title ? item.title : item.id}
                  </ConditionalLink>
                </h3>
              </Grid.Column>
            ))}
          </Grid>
          <Grid columns={3} stackable doubling>
            {items.slice(3).map((item) => (
              //Image listing
              <Grid.Column key={item['@id']}>
                <ConditionalLink item={item} condition={!isEditMode}>
                  <Image
                    src={`http://i.ytimg.com/vi/${item.video_doc_id}/mqdefault.jpg`}
                  />
                </ConditionalLink>
                <h3>
                  <ConditionalLink item={item} condition={!isEditMode}>
                    {item.title ? item.title : item.id}
                  </ConditionalLink>
                </h3>
              </Grid.Column>
            ))}
          </Grid>
        </div>
      ) : (
        // Without video player
        // Image listing
        <div class="container">
          <Grid columns={3} stackable doubling>
            {items.map((item) => (
              <Grid.Column key={item['@id']}>
                <ConditionalLink item={item} condition={!isEditMode}>
                  <Image
                    src={`http://i.ytimg.com/vi/${item.video_doc_id}/mqdefault.jpg`}
                  />
                </ConditionalLink>
                <h3>
                  <ConditionalLink item={item} condition={!isEditMode}>
                    {item.title ? item.title : item.id}
                  </ConditionalLink>
                </h3>
              </Grid.Column>
            ))}
          </Grid>
        </div>
      )}
    </>
  );
};
VideoListing.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  isEditMode: PropTypes.bool,
};

export default VideoListing;
